module.exports = require("lodash/first");